// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XvETpRAeuyRlvbVM1HaX {
  align-items: center;
  column-gap: 0.5rem;
  cursor: pointer;
  display: flex;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
}

.XvETpRAeuyRlvbVM1HaX svg {
  font-size: 0.625rem;
}
`, "",{"version":3,"sources":["webpack://./src/shared/admin/components/Back/Back.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".back {\n  align-items: center;\n  column-gap: 0.5rem;\n  cursor: pointer;\n  display: flex;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.back svg {\n  font-size: 0.625rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"back": `XvETpRAeuyRlvbVM1HaX`
};
export default ___CSS_LOADER_EXPORT___;
